/**
 * Displayed when loading the POS data
 * Notion document that we want to be 1:1 with this array:
 * https://www.notion.so/baemingo/General-hints-tips-tool-highlights-26bf2edfbbe480c58062f08f0ee7289d?showMoveTo=true&saveParent=true
 */
export const DID_YOU_KNOWS = [
  'DidYouKnow.Finance.ScheduledReports',
  'DidYouKnow.Finance.Loans',
  'DidYouKnow.QSR.MultiQSR',
  'DidYouKnow.QSR.ParkedOrders',
  'DidYouKnow.QSR.PreviewProduct',
  'DidYouKnow.QSR.Beepers',
  'DidYouKnow.QSR.ModificationGroupsGrid',
  'DidYouKnow.QSR.BongHistory',
  'DidYouKnow.QSR.CustomName',
  'DidYouKnow.TSR.TableLayout',
  'DidYouKnow.TSR.SplitBills',
  'DidYouKnow.TSR.ActivityColoring',
  'DidYouKnow.OnlineOrdering.ScanQR',
  'DidYouKnow.OnlineOrdering.Shop',
  'DidYouKnow.OnlineOrdering.Codes',
  'DidYouKnow.OnlineOrdering.Segments',
  'DidYouKnow.KDS.GreenVariations',
  'DidYouKnow.Settings.AutomaticEODCash',
  'DidYouKnow.Settings.Receipts',
  'DidYouKnow.Settings.TimeBasedPricing',
  'DidYouKnow.Settings.LayoutButtons',
  'DidYouKnow.Integrations.Deliverect',
  'DidYouKnow.EPOS.LimitServiceType',
  'DidYouKnow.Other.StaffCompetitions',
  'DidYouKnow.Other.StaffCompetitionsFirstPlace',
  'DidYouKnow.Others.OrganizationLogin',
  'DidYouKnow.Other.WasteManagement',
];
